export default "__VITE_ASSET__COiecKin__"